import { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import { languages } from "../../constants";
import classes from "./criteriaSubmission.module.css";
import { Box, Typography, Popover } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { selectLanguage, setLanguage } from "../../slices/auth";

export default function LanguageSelector() {
  const dispatch = useDispatch();
  const language = useSelector(selectLanguage); 
  const [value, setValue] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  return (
    <Box id="bottomActions" style={{paddingTop: '10px'}}>
      <Box onClick={handleOpen} className={classes["selectTitleLanguage"]}>
        <Typography className={classes["selectLanguageText"]}>
          Language:{" "}
        </Typography>
        <Box className={classes["languageSelectBox"]}>
          <Typography className={classes["languageSelectText"]}>
            {language}
          </Typography>
          <Box style={{ display: "flex", justifyContent: "space-between" }}>
            <svg
              height="20"
              width="20"
              viewBox="0 0 20 20"
              aria-hidden="true"
              focusable="false"
              className={anchorEl ? classes.svgRotate : ""}
            >
              <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
            </svg>
          </Box>
        </Box>
      </Box>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{
          width: "355px",
          borderRadius: "10px",
        }}
      >
        <div style={{ padding: "10px" }}>
          {languages.map((lang, index) => (
            <MenuItem
              key={index}
              onClick={() => {
                dispatch(setLanguage(lang));
                handleClose();
              }}
            >
              {lang}
            </MenuItem>
          ))}
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              justifyContent: "center",
              width: "318px",
            }}
          >
            <label>Other:</label>
            <input
              placeholder="Please specify"
              className={classes.languageInput}
              type="text"
              value={value}
              onChange={(e) => {
                const val = e.target.value;
                dispatch(setLanguage(val ? val : "English"));
                setValue(val);
              }}
            />
          </div>
        </div>
      </Popover>
    </Box>
  );
}
